import * as React from 'react';
import { styled } from './druid/./druid/./druid/Utilities';
import { ColorRectangleBase } from '/druid/ColorRectangle.base';
import { getStyles } from '/druid/ColorRectangle.styles';
import { IColorRectangleProps, IColorRectangleStyles, IColorRectangleStyleProps } from '/druid/ColorRectangle.types';

export const ColorRectangle: React.FunctionComponent<IColorRectangleProps> = styled<
  IColorRectangleProps,
  IColorRectangleStyleProps,
  IColorRectangleStyles
>(ColorRectangleBase, getStyles, undefined, { scope: 'ColorRectangle' });
